import React from "react";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import { Link } from "react-router-dom";
import { portfolioFileUrl } from "../../config/portfolioData";
import { useLanguage } from "../../context/LanguageContext";

function PortfolioCard({ project, compact }) {
  const { t } = useLanguage();
  const title = t(project.titleKey);
  const desc = project.descKey ? t(project.descKey) : "";

  const isVideo = project.kind === "video";
  const coverSrc =
    project.kind === "gallery"
      ? portfolioFileUrl(project.folder, project.cover)
      : portfolioFileUrl(project.file);

  return (
    <Card className={`broxe-portfolio-card h-100 ${compact ? "broxe-portfolio-card--compact" : ""}`}>
      <div className="broxe-portfolio-media ratio ratio-16x9">
        {isVideo ? (
          <video
            className="broxe-portfolio-video"
            src={coverSrc}
            controls
            playsInline
            preload="metadata"
            title={title}
          />
        ) : (
          <img
            className="broxe-portfolio-img"
            src={coverSrc}
            alt=""
            loading="lazy"
            decoding="async"
          />
        )}
      </div>
      <Card.Body className="d-flex flex-column">
        <div className="d-flex flex-wrap gap-2 align-items-center mb-2">
          <Badge bg="primary" className="broxe-portfolio-badge">
            {isVideo ? t("portfolio.badgeVideo") : t("portfolio.badgeGallery")}
          </Badge>
        </div>
        <Card.Title as="h3" className="h5 text-white mb-2">
          <Link
            to={`/portfolio#${project.id}`}
            className="text-white text-decoration-none broxe-portfolio-card-title-link"
          >
            {title}
          </Link>
        </Card.Title>
        {desc ? (
          <Card.Text className="text-white-50 small mb-0 flex-grow-1">{desc}</Card.Text>
        ) : null}
      </Card.Body>
    </Card>
  );
}

export default PortfolioCard;
